import { render, staticRenderFns } from "./LogsCard.vue?vue&type=template&id=fb7378f8"
import script from "./LogsCard.vue?vue&type=script&lang=js"
export * from "./LogsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports